import { render, staticRenderFns } from "./createOrUpdate.vue?vue&type=template&id=27ece2e4&"
import script from "./createOrUpdate.vue?vue&type=script&lang=js&"
export * from "./createOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports